import useTranslation from "@babackapp/translations/use-translation";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@babackapp/ui/components/alert";
import { ShieldAlert } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useViewerSuperpowerAwaitsMfa } from "@/lib/rights/use-viewer-is-baback-team";

const ACCOUNT_SETTINGS_PATH = "/account/settings";

/**
 * A super admin account without MFA has no powers (BAB-3035). Points it to the
 * account settings page, reachable without opening any shop.
 */
export default function SuperpowerMfaBanner() {
  const t = useTranslation();
  const isAwaitingMfa = useViewerSuperpowerAwaitsMfa();
  const { pathname } = useLocation();

  // Mon compte repeats it in the MFA card, right above the activation.
  if (!isAwaitingMfa || pathname.endsWith(ACCOUNT_SETTINGS_PATH)) return null;

  return (
    // Fixed, so it does not push the full-height shop layout down; z-40 keeps
    // it under dialogs and sheets (z-50).
    <Alert
      variant="warning"
      className="fixed bottom-4 left-1/2 z-40 w-[min(42rem,calc(100%-2rem))] -translate-x-1/2 shadow-lg"
    >
      <ShieldAlert className="h-4 w-4" />
      <AlertTitle>{t("superAdmin.mfaRequired.title")}</AlertTitle>
      <AlertDescription>
        {t("superAdmin.mfaRequired.description")}{" "}
        <Link to={ACCOUNT_SETTINGS_PATH} className="font-medium underline">
          {t("superAdmin.mfaRequired.action")}
        </Link>
      </AlertDescription>
    </Alert>
  );
}
